(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4586],{

/***/ 1795:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/cart/checkout",
      function () {
        return __webpack_require__(3111);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2175);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(155);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(7258);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9536);
/* harmony import */ var _layout_Footer__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(3981);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(1914);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(7239);
/* harmony import */ var _utils_const__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(3026);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9735);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var __N_SSG = true;
function Home(param1) {
    var header = param1.header, hotelBrands = param1.hotelBrands;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)(), query = ref.query, isReady = ref.isReady, push = ref.push, locale = ref.locale, reload = ref.reload, replace = ref.replace;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), cartItems = ref1[0], setCartItems = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), amount = ref2[0], setAmount = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), quantity1 = ref3[0], setQuantity = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), total = ref4[0], setTotal = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), countries = ref5[0], setCounteries = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), showPop = ref6[0], setShowPop = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), isVoucherValid = ref7[0], setIsVoucherValid = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), voucher = ref8[0], setVoucher = ref8[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (!isReady) return;
        if (query.proccess == "succes" || query.transaction_id) {
            if (!query.sig) return;
            if (total <= 0) return;
            (0,_utils_api__WEBPACK_IMPORTED_MODULE_14__/* .getSigMatch */ .Jv)({
                sig: query.sig,
                id: query.id,
                total: query.total
            }).then(function(res) {
                setShowPop(true);
                if (res.data.result) {
                    (0,_utils_api__WEBPACK_IMPORTED_MODULE_14__/* .postOrderLater */ .GK)({
                        id: query.id
                    });
                    var tempList = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)("cart");
                    tempList.map(function(item) {
                        (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .deleteLocalStorage */ .bv)(item);
                    });
                    (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .deleteLocalStorage */ .bv)("cart");
                    setInterval(function() {
                        window.open("/shop", "_self");
                    }, 1000);
                }
            });
        }
    }, [
        isReady
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var now = function now() {
            var tempList = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)("cart");
            if (!tempList) {
                setCartItems([]);
                return;
            }
            var tempItems = tempList.map(function(item) {
                var temp = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)(item);
                return temp;
            });
            setCartItems(tempItems);
            var tempVoucher = (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .getLocalStorage */ .$o)("shop-voucher");
            if (tempVoucher) {
                setVoucher(tempVoucher);
                (0,_utils_api__WEBPACK_IMPORTED_MODULE_14__/* .postCheckCoupon */ .w1)({
                    code: tempVoucher
                }).then(function(res) {
                    setIsVoucherValid(res.data);
                });
            }
        };
        now();
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        (0,_utils_api__WEBPACK_IMPORTED_MODULE_14__/* .getCountryList */ .Jp)().then(function(res) {
            setCounteries(res.data);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var aTemp = 0, qTemp = 0;
        var dTemp = 0;
        cartItems.map(function(v) {
            qTemp = qTemp + v.quantity;
            aTemp = aTemp + v.price * v.quantity;
        });
        setAmount(aTemp);
        setQuantity(qTemp);
        var totalTemp = aTemp - dTemp;
        if (isVoucherValid && isVoucherValid.isUsable) {
            var tempDisc = (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toNumber)(isVoucherValid.amount.replace(".00", ""));
            if (isVoucherValid.discount_type == "percent") {
                setTotal(totalTemp - totalTemp * (tempDisc / 100));
            } else {
                setTotal(totalTemp - tempDisc > 0 ? totalTemp - tempDisc : 0);
            }
        } else {
            setTotal(totalTemp);
        }
    }, [
        cartItems,
        isVoucherValid
    ]);
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_3__/* .useFormik */ .TA)({
        initialValues: {
            name: "",
            email: "",
            phone: "",
            country: "Indonesia",
            city: "",
            zip: "",
            street: ""
        },
        validationSchema: yup__WEBPACK_IMPORTED_MODULE_9__/* .object */ .Ry({
            name: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().max(20).required(locale == "id" ? "Harus diisi" : "Required"),
            email: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().email(locale == "id" ? "Email tidak valid" : "Please enter a valid email").required(locale == "id" ? "Harus diisi" : "Required"),
            phone: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().matches(_utils_const__WEBPACK_IMPORTED_MODULE_15__/* .phoneRegExp */ .Oj, locale == "id" ? "Nomor telepon tidak valid" : "Phone must be a valid phone number").required(locale == "id" ? "Harus diisi" : "Required"),
            country: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_(),
            city: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            zip: yup__WEBPACK_IMPORTED_MODULE_9__/* .number */ .Rx().required(locale == "id" ? "Harus diisi" : "Required"),
            street: yup__WEBPACK_IMPORTED_MODULE_9__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required")
        }),
        onSubmit: function() // { name, email, message, phone },
        // { setSubmitting, setStatus }
        {}
    });
    function handleClick() {
        return _handleClick.apply(this, arguments);
    }
    function _handleClick() {
        _handleClick = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var _values, email, name, city, country, street, zip, phone;
            return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (formik.isValid) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        formik.setSubmitting(true);
                        (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .deleteLocalStorage */ .bv)("shop-voucher");
                        _values = formik.values, email = _values.email, name = _values.name, city = _values.city, country = _values.country, street = _values.street, zip = _values.zip, phone = _values.phone;
                        _ctx.next = 7;
                        return (0,_utils_api__WEBPACK_IMPORTED_MODULE_14__/* .postOrder */ .mv)({
                            name: name,
                            email: email,
                            phone: phone,
                            city: city,
                            country: country,
                            street: street,
                            // payment: "cod",
                            total: total,
                            slug: "parador",
                            zip: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(zip),
                            price: (0,lodash__WEBPACK_IMPORTED_MODULE_4__.toString)(total),
                            coupon: voucher,
                            items: cartItems.map(function(param) {
                                var databaseId = param.databaseId, quantity = param.quantity;
                                return {
                                    product_id: databaseId,
                                    quantity: quantity
                                };
                            })
                        }).then(function(res) {
                            res.status == 200 && formik.setStatus("success");
                            //COD
                            // setShowPop(true);
                            // const tempList = getLocalStorage(`cart`);
                            // tempList.map((item: any) => {
                            //   deleteLocalStorage(item);
                            // });
                            // deleteLocalStorage(`cart`);
                            //RDP PAYMENT
                            window.open(res.data.redirect_url, "_self");
                        });
                    case 7:
                        formik.setSubmitting(false);
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handleClick.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                title: "Checkout | Parador Hotels & Resorts"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                headerItem: header,
                hotelBrands: hotelBrands,
                isHomepage: false
            }),
            (showPop || formik.isSubmitting) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                position: "fixed",
                top: 0,
                zIndex: 5,
                bg: "blackAlpha.600",
                h: "100vh",
                w: "100vw",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AbsoluteCenter */ .umj, {
                    w: [
                        "90vw",
                        "70vw",
                        "50vw"
                    ],
                    h: [
                        "60vh",
                        "50vh",
                        "40vh"
                    ],
                    bg: "black",
                    px: 20,
                    borderColor: "white",
                    borderRadius: 0,
                    borderWidth: 10,
                    zIndex: 6,
                    children: formik.isSubmitting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                        w: "100%",
                        h: "100%",
                        gap: 10,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Spinner */ .$jN, {
                            color: "white",
                            size: "xl"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                        w: "100%",
                        h: "100%",
                        flexDir: "column",
                        gap: 10,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                as: "h3",
                                fontWeight: 400,
                                letterSpacing: "widest",
                                fontSize: "xl",
                                color: "white",
                                textAlign: "center",
                                children: "Thank you for purchasing, please check your email for payment"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                    variant: "outline",
                                    color: "white",
                                    onClick: function() {
                                        push("/shop");
                                    },
                                    children: locale == "id" ? "TUTUP" : "CLOSE"
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                as: "h1",
                                m: 0,
                                mb: 2,
                                fontWeight: 400,
                                letterSpacing: "widest",
                                color: "black",
                                children: locale == "id" ? "BELANJA" : "SHOP"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                m: 0,
                                maxW: {
                                    base: "90%",
                                    md: "50%"
                                },
                                align: "left",
                                color: "blackAlpha.700",
                                children: locale == "id" ? "Nikmati penawaran & promosinya" : "Enjoy the offers & promotions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                        mb: 10,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                            orientation: "horizontal",
                            borderColor: "blackAlpha.500"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                        mb: 2,
                        as: "h1",
                        fontWeight: 400,
                        letterSpacing: "wider",
                        textAlign: "left",
                        children: locale == "id" ? "Pembayaran" : "Checkout"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                        gap: 12,
                        flexDir: [
                            "column",
                            null,
                            null,
                            "row"
                        ],
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Grid */ .rjZ, {
                                flex: 2,
                                templateColumns: [
                                    "repeat(2, 1fr)",
                                    null,
                                    "repeat(4, 1fr)"
                                ],
                                columnGap: [
                                    2,
                                    4,
                                    8
                                ],
                                rowGap: [
                                    3,
                                    null,
                                    0
                                ],
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                        colSpan: 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: "space-between",
                                            flexDir: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                    htmlFor: "name",
                                                    fontSize: "xl",
                                                    textTransform: "uppercase",
                                                    fontWeight: 400,
                                                    children: locale == "id" ? "Nama*" : "Name*"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                            fontSize: "sm",
                                                            id: "name",
                                                            name: "name",
                                                            type: "text",
                                                            borderRadius: 0,
                                                            placeholder: locale == "id" ? "Nama Anda" : "Your Name",
                                                            onChange: formik.handleChange,
                                                            onBlur: formik.handleBlur,
                                                            value: formik.values.name
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                            fontSize: "xs",
                                                            color: "red.500",
                                                            mt: 1,
                                                            children: formik.errors.name
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                        colSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: "space-between",
                                            flexDir: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                    htmlFor: "email",
                                                    fontSize: "xl",
                                                    textTransform: "uppercase",
                                                    fontWeight: 400,
                                                    children: "Email*"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                            fontSize: "sm",
                                                            id: "email",
                                                            name: "email",
                                                            type: "email",
                                                            borderRadius: 0,
                                                            placeholder: "Your@email.com",
                                                            onChange: formik.handleChange,
                                                            onBlur: formik.handleBlur,
                                                            value: formik.values.email
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                            fontSize: "xs",
                                                            color: "red.500",
                                                            mt: 1,
                                                            children: formik.errors.email
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                        colSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: "space-between",
                                            flexDir: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                    htmlFor: "phone",
                                                    fontSize: "xl",
                                                    textTransform: "uppercase",
                                                    fontWeight: 400,
                                                    children: locale == "id" ? "Telepon*" : "Phone*"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                            fontSize: "sm",
                                                            id: "phone",
                                                            name: "phone",
                                                            type: "tel",
                                                            borderRadius: 0,
                                                            placeholder: "0812345",
                                                            onChange: formik.handleChange,
                                                            onBlur: formik.handleBlur,
                                                            value: formik.values.phone
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                            fontSize: "xs",
                                                            color: "red.500",
                                                            mt: 1,
                                                            children: formik.errors.phone
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                        colSpan: 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: "space-between",
                                            flexDir: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                    htmlFor: "country",
                                                    fontSize: "xl",
                                                    textTransform: "uppercase",
                                                    fontWeight: 400,
                                                    children: locale == "id" ? "Negara*" : "Country*"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .PhF, {
                                                        borderRadius: 0,
                                                        fontSize: "sm",
                                                        defaultValue: "Indonesia",
                                                        placeholder: "Indonesia",
                                                        onChange: function(e) {
                                                            formik.setValues(_objectSpread({}, formik.values, {
                                                                country: e.target.value
                                                            }));
                                                        },
                                                        children: countries.map(function(country) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                value: country.code,
                                                                children: country.name
                                                            }, country.code);
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                        colSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: "space-between",
                                            flexDir: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                    htmlFor: "city",
                                                    fontSize: "xl",
                                                    textTransform: "uppercase",
                                                    fontWeight: 400,
                                                    children: locale == "id" ? "Kota*" : "City*"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                            fontSize: "sm",
                                                            id: "city",
                                                            name: "city",
                                                            type: "text",
                                                            borderRadius: 0,
                                                            placeholder: "Jakarta",
                                                            onChange: formik.handleChange,
                                                            onBlur: formik.handleBlur,
                                                            value: formik.values.city
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                            fontSize: "xs",
                                                            color: "red.500",
                                                            mt: 1,
                                                            children: formik.errors.city
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                        colSpan: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: "space-between",
                                            flexDir: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                    htmlFor: "zip",
                                                    fontSize: "xl",
                                                    textTransform: "uppercase",
                                                    fontWeight: 400,
                                                    children: locale == "id" ? "Kode Pos*" : "Zip Code*"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                            fontSize: "sm",
                                                            id: "zip",
                                                            name: "zip",
                                                            type: "number",
                                                            borderRadius: 0,
                                                            placeholder: "000",
                                                            onChange: formik.handleChange,
                                                            onBlur: formik.handleBlur,
                                                            value: formik.values.zip
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                            fontSize: "xs",
                                                            color: "red.500",
                                                            mt: 1,
                                                            children: formik.errors.zip
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .GridItem */ .P4e, {
                                        colSpan: 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                            justify: "space-between",
                                            flexDir: "column",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                    htmlFor: "street",
                                                    fontSize: "xl",
                                                    textTransform: "uppercase",
                                                    fontWeight: 400,
                                                    children: locale == "id" ? "Alamat*" : "Street*"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Textarea */ .gxH, {
                                                            fontSize: "sm",
                                                            id: "street",
                                                            name: "street",
                                                            borderRadius: 0,
                                                            placeholder: "St. New Y",
                                                            onChange: formik.handleChange,
                                                            onBlur: formik.handleBlur,
                                                            value: formik.values.street
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                            fontSize: "xs",
                                                            color: "red.500",
                                                            mt: 1,
                                                            children: formik.errors.street
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                flexDir: "column",
                                align: "center",
                                maxW: [
                                    "100%",
                                    null,
                                    null,
                                    "25%"
                                ],
                                flex: 1,
                                color: "blackAlpha.600",
                                gap: 6,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                        align: "center",
                                        gap: 4,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                                                h: 62,
                                                w: 62,
                                                borderWidth: 2,
                                                borderRadius: "50%",
                                                borderColor: "blackAlpha.600",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_7__/* .IoCartOutline */ .toq, {
                                                    size: 32
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                fontSize: "2xl",
                                                letterSpacing: "widest",
                                                fontWeight: 400,
                                                children: locale == "id" ? "Keranjang" : "Your Cart"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                        flexDir: "column",
                                        borderWidth: 1,
                                        borderRadius: 16,
                                        borderColor: "blackAlpha.200",
                                        w: "100%",
                                        gap: 3,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                pt: 4,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "JUMLAH" : "AMOUNT"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .formatRupiah */ .b7)(amount)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "KUANTITAS" : "QUANTITY"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: quantity1
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "BIAYA ANTAR" : "DELIVERY FEE"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "GRATIS" : "FREE"
                                                    })
                                                ]
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 500,
                                                px: 6,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: locale == "id" ? "TIPE PENGIRIMAN" : "DELIVERY TYPE"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: "Regular"
                                                    })
                                                ]
                                            }),
                                            isVoucherValid && isVoucherValid.isUsable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                            orientation: "horizontal"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        justify: "space-between",
                                                        fontSize: "xs",
                                                        fontWeight: 500,
                                                        px: 6,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                as: "span",
                                                                children: locale == "id" ? "DISKON" : "DISCOUNT"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                as: "span",
                                                                children: [
                                                                    isVoucherValid.discount_type == "percent" ? isVoucherValid.amount.replace(".00", "") : (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .formatRupiah */ .b7)(isVoucherValid.amount.replace(".00", "")),
                                                                    isVoucherValid.discount_type == "percent" && "%"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                mb: -0.2,
                                                justify: "space-between",
                                                fontSize: "xs",
                                                fontWeight: 600,
                                                bg: "blackAlpha.200",
                                                color: "blackAlpha.700",
                                                p: 6,
                                                borderBottomRadius: 15,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: "TOTAL"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                        as: "span",
                                                        children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_16__/* .formatRupiah */ .b7)(total)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                        bg: "black",
                                        color: "white",
                                        w: "100%",
                                        py: 6,
                                        fontSize: "md",
                                        onClick: handleClick,
                                        disabled: formik.isSubmitting || !(cartItems.length > 0) || !(formik.isValid && Object.keys(formik.touched).length > 0),
                                        children: locale == "id" ? "Beli" : "Purchase"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Footer__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                loc: header.location_url,
                address: header.location_long,
                email: header.email,
                phone: header.phone
            })
        ]
    });
};


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ }),

/***/ 1082:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,4939,3981,9774,2888,179], function() { return __webpack_exec__(1795); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);